import { AlignmentType, HeadingLevel, ImageRun, Paragraph, TextRun, WidthType } from 'docx';
import fourthimg from '../../../../../../../src/Assests/ReportImages/image4.png'
import methodology from '../../../../../../Assests/ReportImages/methodologyDiscovery.png'

const heading4 = await fetch(fourthimg).then(response => response.blob())
const methodologyimg = await fetch(methodology).then(response => response.blob())

const imagefour = new ImageRun({
    type: 'png',
    data: await heading4.arrayBuffer(),
    transformation: {
        width: 150,
        height: 120
    },
});

const discoveryimg = new ImageRun({
    type: 'png',
    data: await methodologyimg.arrayBuffer(),
    transformation: {
        width: 676,
        height: 250
    },
});

export const imageFour = new Paragraph({
    indent: { left: 130 },
    spacing: { before: 50 },
    alignment: AlignmentType.LEFT,
    children: [imagefour]
})

export const methodologyHeading = new Paragraph({
    indent: { left: 600 },
    spacing: { before: 100 },
    children: [
        new TextRun({
            text: "4.  Setup & Methodology ",
            size: 40,
            color: "0189f9",
            font: "Gill Sans MT",
            bold: true,
            italics: false
        })
    ],
    heading: HeadingLevel.HEADING_2,
})

export const methodologyText = new Paragraph({
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 600, right: 600 },
    spacing: { line: 300, before: 300, after: 300 },
    alignment: AlignmentType.JUSTIFIED,
    children: [
        new TextRun({
            text: "The mobile application penetration testing methodology is typically based on the application security methodology. The focus shifts from traditional application security, where the primary threat is from multiple sources over the Internet. The key difference is in the client-side security, file system, hardware, and network security. Traditionally for mobile applications, an end user is in control of the device. ISECURION used the OWASP Mobile Security Project (OWASP) testing guide for conducting penetration test of the systems and applications. The testing was done to simulate as closely as possible the viewpoint of completely external attacker, the steps involved are",
            size: 24,
            color: '0f0f3f',
            italics: false,
            font: "Calibri",
        })
    ]
})

export const steps1BulletOne = new Paragraph({
    text: "Discovery",
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1800, right: 600 },

    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})

export const steps1BulletTwo = new Paragraph({
    text: "Assessment/Analysis",
    width: { size: 100, type: WidthType.PERCENTAGE },
    indent: { left: 1800, right: 600 },
    alignment: AlignmentType.JUSTIFIED,
    spacing: { line: 170, before: 300, after: 300 },
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})

export const steps1BulletThree = new Paragraph({
    text: "Exploitation",
    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 170, before: 300, after: 300 },
    indent: { left: 1800, right: 600 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})
export const steps1BulletFour = new Paragraph({
    text: "Reporting",

    width: { size: 100, type: WidthType.PERCENTAGE },
    spacing: { line: 170, before: 300, after: 300 },
    indent: { left: 1800, right: 600 },
    alignment: AlignmentType.JUSTIFIED,
    bullet: { level: 0 },
    children: [
        new TextRun({
            size: 24,
            font: "Calibri",
            color: "0f0f3f",
            italics: false,
        }),
    ],
})
export const discoverymethodology = new Paragraph({
    indent: { left: 100 },
    spacing: { before: 500 },
    alignment: AlignmentType.CENTER,
    children: [discoveryimg]
})